<template>
  <div>
    <h2>{{ title }}</h2>
    <b-card no-body class="mb-5" border-variant="grey-mid">
      <b-tabs card vertical end>
        <b-tab tag='h2' title="View:" disabled></b-tab>
        <b-tab title="Table" active>
          <b-card-body>
            <b-row>
              <b-col lg="3">
                <p><b-button variant="outline-secondary" v-on:click="activate({filter:'all'})">Reset filters (show all)</b-button></p>
                <b-tabs>
                  <b-tab v-for="filter in filters" :title="filter.title" :key="filter.title">
                    <div class="tree-list mt-2"><node-tree v-on:activate="activate($event)" v-for="node in filter.options" :node="node" :name="filter.name" :key="node.ID" :counts="counts" /></div>
                  </b-tab>
                </b-tabs>
              </b-col>
              <b-col lg="9">
                <div class="map-container" :id="'map-' + this._uid"></div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-tab>
        <b-tab v-if="messages" title="Log">
          <b-card-body>
            <b-container>
              <b-row>
                <b-col>
                  <b-list-group>
                    <b-list-group-item v-for="message in messages" class="text-monospace" :key="message">{{ message }}</b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-container>
          </b-card-body>
        </b-tab>
      </b-tabs>
      <b-card-footer v-if="method" footer-border-variant="grey-mid">
        <div class="text-monospace small text-muted">
          <strong>Method:</strong> {{ method }}
        </div>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import NodeTree from "./NodeTree";

export default {
  name: 'MioMap',
  props: {
    title: String,
    data: Array,
    messages: Array,
    method: String,
    filters: Array,
  },
  components: {
    NodeTree
  },
  methods: {
    init() {
      this.map = L.map(`map-${this._uid}`).setView([-16.9465096,27.2504284], 5);
      this.tileLayer = L.tileLayer(
        'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
        }
      );
      this.tileLayer.addTo(this.map);

      this.layers = {
        all: L.layerGroup()
      };

      this.data.forEach(location => {
        if (!location.lat || !location.lng) {
          return;
        }

        let popupContent = `<h2>${location.title}</h2>`;
        let marker = L.marker([location.lat, location.lng], { title: location.title }).bindPopup(popupContent).addTo(this.layers.all);
        location.filters.forEach(filter => {
          filter.values.forEach(value => {
            if (!this.layers[`${filter.name}.${value}`]) {
              this.layers[`${filter.name}.${value}`] = L.layerGroup();
            }
            marker.addTo(this.layers[`${filter.name}.${value}`]);
          })
        });
      });

      this.layers.all.addTo(this.map);
      let bounds = this.layers.all.getLayers().map(layer => layer.getLatLng());
      this.map.fitBounds(bounds);
    },
    activate(params) {
      let { filter, value } = params;
      let ID = filter === 'all' ? 'all' : `${filter}.${value}`;
      Object.keys(this.layers).forEach(layer => this.layers[layer].remove(this.map));
      if (!this.layers[ID]) {
        console.log('No locations.');
        return;
      }
      this.layers[ID].addTo(this.map);
      let bounds = this.layers[ID].getLayers().map(layer => layer.getLatLng());
      this.map.fitBounds(bounds);
    },
  },
  created() {
    if (!this.data) {
      return;
    }

    this.counts = {
      all: 0
    };

    this.data.forEach(location => {
      location.filters.forEach(filter => {
        filter.values.forEach(value => {
          let ID = `${filter.name.trim()}.${value.trim()}`;
          if (!this.counts[ID]) {
            this.counts[ID] = { good: 0, bad: 0 };
          }
          if (location.lat && location.lng) {
            this.counts.all++;
            this.counts[ID].good++;
          } else {
            this.counts[ID].bad++;
          }
        })
      });
    });

    this.$loadScript("https://unpkg.com/leaflet@1.6.0/dist/leaflet.js")
    .then(() => {
      this.init();
    })
    .catch(() => {
      // Failed to fetch script
    });
  },
}
</script>

<style>
@import 'https://unpkg.com/leaflet@1.6.0/dist/leaflet.css';

.map-container {
  height: 100vh;
}

.tree-list details {
  margin-bottom: 0.125rem;
}

.tree-list details details {
  padding-left: 1rem;
}

</style>
